export class TransferBaseRequestDto {
	public Environment: string;
	public AuthenticationMethod: string;

	public constructor(params: Partial<TransferBaseRequestDto>) {
		this.Environment = params.Environment;
		this.AuthenticationMethod = params.AuthenticationMethod;
	}
}
